import { SERVICE } from './constants'

export const INIT_CONFIG = `${SERVICE}/INIT_CONFIG`

export const COUNTRIES = `${SERVICE}/COUNTRIES`
export const COUNTRIES_SUCCESS = `${SERVICE}/COUNTRIES_SUCCESS`
export const COUNTRIES_ERROR = `${SERVICE}/COUNTRIES_ERROR`
export const SET_COUNTRIES_INFORMATION = `${SERVICE}/SET_COUNTRIES_INFORMATION`
export const RESET_COUNTRIES_INFORMATION = `${SERVICE}/RESET_COUNTRIES_INFORMATION`

export const SET_LOCALE = `${SERVICE}/SET_LOCALE`
export const SET_LOCALE_SUCCESS = `${SERVICE}/SET_LOCALE_SUCCESS`
export const SET_LOCALE_ERROR = `${SERVICE}/SET_LOCALE_ERROR`

export const SET_IS_CONFIG_LOADED = `${SERVICE}/SET_IS_CONFIG_LOADED`
export const RESET_IS_CONFIG_LOADED = `${SERVICE}/RESET_IS_CONFIG_LOADED`

export const CPV = `${SERVICE}/CPV`
export const CPV_SUCCESS = `${SERVICE}/CPV_SUCCESS`
export const CPV_ERROR = `${SERVICE}/CPV_ERROR`
export const SET_CPV_INFORMATION = `${SERVICE}/SET_CPV_INFORMATION`
export const RESET_CPV_INFORMATION = `${SERVICE}/RESET_CPV_INFORMATION`

export const DOCUMENTS = `${SERVICE}/DOCUMENTS`
export const DOCUMENTS_SUCCESS = `${SERVICE}/DOCUMENTS_SUCCESS`
export const DOCUMENTS_ERROR = `${SERVICE}/DOCUMENTS_ERROR`
export const SET_DOCUMENTS = `${SERVICE}/SET_DOCUMENTS`
export const RESET_DOCUMENTS = `${SERVICE}/RESET_DOCUMENTS`
